// FETCH ALL PROCESS_COST_PER_PCS
export const FETCH_PROCESS_COST_PER_PCS_REQUEST = 'FETCH_PROCESS_COST_PER_PCS_REQUEST';
export const FETCH_PROCESS_COST_PER_PCS_SUCCESS = 'FETCH_PROCESS_COST_PER_PCS_SUCCESS';
export const FETCH_PROCESS_COST_PER_PCS_FAILURE = 'FETCH_PROCESS_COST_PER_PCS_FAILURE';

export const CHECK_PROCESS_COST_PER_PCS_PROCESS_ID_REQUEST = 'CHECK_PROCESS_COST_PER_PCS_PROCESS_ID_REQUEST';
export const CHECK_PROCESS_COST_PER_PCS_PROCESS_ID_SUCCESS = 'CHECK_PROCESS_COST_PER_PCS_PROCESS_ID_SUCCESS';
export const CHECK_PROCESS_COST_PER_PCS_PROCESS_ID_FAILURE = 'CHECK_PROCESS_COST_PER_PCS_PROCESS_ID_FAILURE';

// CREATE PROCESS_COST_PER_PCS
export const CREATE_PROCESS_COST_PER_PCS_REQUEST = 'CREATE_PROCESS_COST_PER_PCS_REQUEST';
export const CREATE_PROCESS_COST_PER_PCS_SUCCESS = 'CREATE_PROCESS_COST_PER_PCS_SUCCESS';
export const CREATE_PROCESS_COST_PER_PCS_FAILURE = 'CREATE_PROCESS_COST_PER_PCS_FAILURE';

// CREATE PROCESS_COST_PER_PCS
export const FETCH_RATE_PER_PCS_INVOICE_DATA_REQUEST = 'FETCH_RATE_PER_PCS_INVOICE_DATA_REQUEST';
export const FETCH_RATE_PER_PCS_INVOICE_DATA_SUCCESS = 'FETCH_RATE_PER_PCS_INVOICE_DATA_SUCCESS';
export const FETCH_RATE_PER_PCS_INVOICE_DATA_FAILURE = 'FETCH_RATE_PER_PCS_INVOICE_DATA_FAILURE';

// UPDATE PROCESS_COST_PER_PCS
export const UPDATE_PROCESS_COST_PER_PCS_REQUEST = 'UPDATE_PROCESS_COST_PER_PCS_REQUEST';
export const UPDATE_PROCESS_COST_PER_PCS_SUCCESS = 'UPDATE_PROCESS_COST_PER_PCS_SUCCESS';
export const UPDATE_PROCESS_COST_PER_PCS_FAILURE = 'UPDATE_PROCESS_COST_PER_PCS_FAILURE';

// FETCH SINGLE STATE
export const FETCH_SINGLE_PROCESS_COST_PER_PCS_REQUEST = 'FETCH_SINGLE_PROCESS_COST_PER_PCS_REQUEST';
export const FETCH_SINGLE_PROCESS_COST_PER_PCS_SUCCESS = 'FETCH_SINGLE_PROCESS_COST_PER_PCS_SUCCESS';
export const FETCH_SINGLE_PROCESS_COST_PER_PCS_FAILURE = 'FETCH_SINGLE_PROCESS_COST_PER_PCS_FAILURE';

// DELETE PROCESS_COST_PER_PCS
export const DELETE_PROCESS_COST_PER_PCS_REQUEST = 'DELETE_PROCESS_COST_PER_PCS_REQUEST';
export const DELETE_PROCESS_COST_PER_PCS_SUCCESS = 'DELETE_PROCESS_COST_PER_PCS_SUCCESS';
export const DELETE_PROCESS_COST_PER_PCS_FAILURE = 'DELETE_PROCESS_COST_PER_PCS_FAILURE';

// FETCH ALL PROCESS_COST_PER_PCS BY STYLE DETAIL ID
export const FETCH_PROCESS_COST_PER_PCS_BY_STYLE_DETAIL_ID_REQUEST = 'FETCH_PROCESS_COST_PER_PCS_BY_STYLE_DETAIL_ID_REQUEST';
export const FETCH_PROCESS_COST_PER_PCS_BY_STYLE_DETAIL_ID_SUCCESS = 'FETCH_PROCESS_COST_PER_PCS_BY_STYLE_DETAIL_ID_SUCCESS';
export const FETCH_PROCESS_COST_PER_PCS_BY_STYLE_DETAIL_ID_FAILURE = 'FETCH_PROCESS_COST_PER_PCS_BY_STYLE_DETAIL_ID_FAILURE';

export const RESET_PROCESS_COST_PER_PCS_BY_STYLE_DATA = 'RESET_PROCESS_COST_PER_PCS_BY_STYLE_DATA';

export const RESET_PROCESS_COST_PER_PCS_INFO = 'RESET_PROCESS_COST_PER_PCS_INFO';

export const CREATE_PROCESS_COST_PER_PCS_FORM = 'CREATE_PROCESS_COST_PER_PCS_FORM';

export const UPDATE_PROCESS_COST_PER_PCS_FORM = 'UPDATE_PROCESS_COST_PER_PCS_FORM';
export const ASSIGN_PROCESS_TOGGLE_PCS = 'ASSIGN_PROCESS_TOGGLE_PCS';

//FETCH INVOICE DATA
export const FETCH_PROCESS_COST_PER_PCS_INVOICE_REQUEST = 'FETCH_PROCESS_COST_PER_PCS_INVOICE_REQUEST';
export const FETCH_PROCESS_COST_PER_PCS_INVOICE_SUCCESS = 'FETCH_PROCESS_COST_PER_PCS_INVOICE_SUCCESS';
export const FETCH_PROCESS_COST_PER_PCS_INVOICE_FAILURE = 'FETCH_PROCESS_COST_PER_PCS_INVOICE_FAILURE';

export const RESET_PROCESS_COST_PER_PCS_INVOICE = 'RESET_PROCESS_COST_PER_PCS_INVOICE';
